class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.header = document.querySelector('.header-wrapper');
    if (this.header) this.header.preventHide = false;

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    // Redirection depuis /cart : ouvrir le drawer si ?cart=open
    if (window.location.search.includes('cart=open')) {
      this.open();
      const url = new URL(window.location);
      url.searchParams.delete('cart');
      window.history.replaceState({}, '', url);
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.header) this.header.preventHide = true;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    requestAnimationFrame(() => { this.classList.add('animate', 'active'); });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      const runTrap = () => trapFocus(containerToTrapFocusOn, focusElement);
      if (typeof requestIdleCallback !== 'undefined') {
        requestIdleCallback(runTrap, { timeout: 100 });
      } else {
        setTimeout(runTrap, 0);
      }
    }, { once: true });

    document.body.classList.add('overflow-hidden-drawer');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden-drawer');
    if (this.header) this.header.preventHide = false;
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    let itemCount = typeof parsedState.item_count === 'number' ? parsedState.item_count : (Array.isArray(parsedState.items) ? parsedState.items.length : -1);

    this.getSectionsToRender().forEach((section) => {
      if (section.id === 'cart-icon-bubble') return;
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!sectionElement) return;
      const sectionHtml = parsedState.sections && parsedState.sections[section.id];
      if (sectionHtml) sectionElement.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
    });

    if (itemCount < 0 && parsedState.sections) {
      fetch((window.routes && window.routes.cart_url) ? (window.routes.cart_url + '.js') : '/cart.js').then((r) => r.json()).then((cart) => { this.updateCartCountBubble(cart.item_count || 0); }).catch(() => {});
    } else {
      this.updateCartCountBubble(itemCount >= 0 ? itemCount : 0);
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      initCartReassuranceSlider();
    });
  }

  updateCartCountBubble(count) {
    const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!bubble) return;
    const visibleSpan = bubble.querySelector('span[aria-hidden="true"]');
    const a11ySpan = bubble.querySelector('.visually-hidden');
    if (visibleSpan) visibleSpan.textContent = count < 100 ? count : '99+';
    if (a11ySpan && typeof count === 'number') a11ySpan.textContent = count === 0 ? '' : (count === 1 ? (window.themeStrings && window.themeStrings.cart_count_one) || '1 item' : (window.themeStrings && window.themeStrings.cart_count_other) || count + ' items');
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

function initCartReassuranceSlider() {
  const roots = document.querySelectorAll('.reassurance-slider--cart, [id^="reassurance-slider-cart-"]');
  roots.forEach((root) => {
    if (root._sliderInitialized) return;
    root._sliderInitialized = true;

    if (root._sliderTimer) clearInterval(root._sliderTimer);

    const slides = root.querySelectorAll('.reassurance-slider__slide');
    const dots = root.querySelectorAll('.reassurance-slider__dot');
    const touchArea = root.querySelector('.reassurance-slider__content');
    let current = 0;
    const delay = parseInt(root.dataset.autoplayDelay, 10) || 4000;
    const SWIPE_THRESHOLD = 50;

    function showSlide(index) {
      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    }

    function nextSlide() {
      current = (current + 1) % slides.length;
      showSlide(current);
    }

    function prevSlide() {
      current = (current - 1 + slides.length) % slides.length;
      showSlide(current);
    }

    function goToSlide(index) {
      current = index;
      showSlide(current);
      if (root._sliderTimer) clearInterval(root._sliderTimer);
      root._sliderTimer = setInterval(nextSlide, delay);
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => goToSlide(index));
    });

    if (touchArea && slides.length > 1) {
      let touchStartX = 0;
      touchArea.addEventListener('touchstart', (e) => {
        touchStartX = e.targetTouches[0].clientX;
      }, { passive: true });
      touchArea.addEventListener('touchend', (e) => {
        const touchEndX = e.changedTouches[0].clientX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) >= SWIPE_THRESHOLD) {
          if (diff > 0) nextSlide();
          else prevSlide();
          if (root._sliderTimer) clearInterval(root._sliderTimer);
          root._sliderTimer = setInterval(nextSlide, delay);
        }
      }, { passive: true });
    }

    if (slides.length > 1) {
      root._sliderTimer = setInterval(nextSlide, delay);
    }
  });
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  onCartUpdate() {
    // Le drawer est mis à jour par renderContents (product-form) — ne pas fetch main-cart-items
    // pour éviter requête inutile et contenu incorrect
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartReassuranceSlider);
} else {
  initCartReassuranceSlider();
}
